// extracted by mini-css-extract-plugin
module.exports = {"richWithLabel":"RichWithLabel_richWithLabel__HQrUz","richText":"RichWithLabel_richText__3oX8k"};